import styled from "styled-components";
import { theme } from "../../../theme";

const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 36px 32px;
  box-sizing: border-box;
`;

const ModalBody = styled.div`
  width: 100%;
  position: relative;

  & figure {
    & img {
      width: 100%;
    }
  }
`;

const ModalConfirmTitle = styled.div`
  ${theme.typo.heading.b18}
`;

export { ModalBody, ModalConfirmTitle, ModalContainer };
